<template>
  <div :class="[`input-button-state-${state ? state : 'none'}`, `text-align-${textAlign}`, disabled ? 'disabled' : 'active']" class="input-button td-200">
    <div class="input-button-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputButton',
  props: {
    state: {
      // null, 'active' or 'active-light'
      // active = active
      // active-light = f.eks. "moved, so valid" in the sorting one (since you ALWAYS have to move)
      type: String,
      default: null,
      required: false,
    },
    textAlign: {
      type: String,
      default: 'left',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};

</script>

<style lang="scss" scoped>
.input-button {
  background-color: #C7D3DA;
  border-radius: 15px;
  min-height: 40px;
  font-weight: 600;
  color: #557F97;
  transition-property: background-color, color;
  //transition-duration: 200ms;
  transition-timing-function: ease-out;
  padding: 10px 15px;
  cursor: pointer;

  &.text-align-left {
    text-align: left;
  }

  &.text-align-center {
    text-align: center;
  }

  &.text-align-right {
    text-align: right;
  }

  &.disabled, &:disabled {
    opacity: .8;
    cursor: not-allowed;
  }

  &.input-button-state-active {
    background-color: #45A4CD;
    color: #EDF1F4;
  }

  &.input-button-state-active-light {
    background-color: #6AB8DA;
    color: #EDF1F4;
  }

  &.input-button-state-dev {
    background-color: #519872;
    color: #EDF1F4;
  }
}
</style>
